<template>
    <article-category-create-edit-form isEdit/>
</template>

<script>
import ArticleCategoryCreateEditForm from './components/ArticleCategoryCreateEditForm.vue';
export default {
    components:{
        ArticleCategoryCreateEditForm
    }
}
</script>